module.exports = __webpack_public_path__ + "img/installer-win-03.467ac54e.png";